// extracted by mini-css-extract-plugin
export var aboveInput = "_mt-0";
export var actionButton = "_mt-5";
export var actionButtonContainer = "_mt-1";
export var actionIcon = "_mt-6";
export var aiInfoContainer = "_mt-2";
export var attachmentWrapper = "_mt-7";
export var bold = "_mt-3";
export var checkIcon = "_mt-8";
export var clickingRecipientBar = "_mt-11";
export var commentThreadSwitch = "_mt-a";
export var draftImage = "_mt-b";
export var draftImageContainer = "_mt-c";
export var draftImages = "_mt-e";
export var editButton = "_mt-g";
export var editor = "_mt-f";
export var editorContainer = "_mt-y";
export var editorErrorTooltipWrapper = "_mt-9";
export var headerDivider = "_mt-h";
export var icon = "_mt-i";
export var info = "_mt-j";
export var internal = "_mt-n";
export var internalDivider = "_mt-k";
export var internalMessage = "_mt-l";
export var messageInputCard = "_mt-m";
export var messageInputForm = "_mt-o";
export var messageInputFormInternal = "_mt-p";
export var options = "_mt-q";
export var publicMessageCustomer = "_mt-s";
export var publicMessageMerchant = "_mt-r";
export var removeImageButton = "_mt-d";
export var replyButtons = "_mt-t";
export var showSignatureButton = "_mt-u";
export var spinner = "_mt-v";
export var verticalButtonDivider = "_mt-4";
export var visibilitySelector = "_mt-w";
export var warning = "_mt-x";
export var wrappingText = "_mt-z";
export var writingInternalNoteTopBorder = "_mt-10";